<template>
    <b-alert
    :variant="variant"
    :show="true"
    >
    <div class="d-flex align-items-center shadow">
        <h4 class="alert-heading mr-1" :class="'text-'+variant">
          Ativar integração com o Governo (RNDS)?
        </h4>
        <b-form-group class="m-0">
            <b-form-radio-group
                id="radio-button-integracao"
                v-model="valueIntegracao"
                name="integracaoRnds"
                :options="option"
                @input="emitEventIntegracaoRnds"
                class="radio-campaign"
                :class="disabled ? 'custom-control-'+variant : 'custom-control-'+variant+'-campaign'"
                :disabled="disabled"
            />
        </b-form-group>
    </div>
    <div class="alert-body" v-if="valueIntegracao!=null">
        <span class="font-weight-normal" :class="'text-'+variant" v-if="valueIntegracao">
            Esta campanha enviará os dados dos seus vacinados à Rede Nacional de Saúde
        </span>
        <span class="font-weight-normal" :class="'text-'+variant" v-else>
            Esta campanha NÃO enviará os dados dos seus vacinados à Rede Nacional de Saúde
        </span>
    </div>
    </b-alert>
  </template>

  <script>
  import { BRow, BCol, BForm, BFormGroup, BFormInput,  BFormRadioGroup, BButton, BAlert } from 'bootstrap-vue';
  import { ValidationProvider, ValidationObserver } from 'vee-validate';
  import vSelect from 'vue-select';

  export default {
      components: {
          BRow, BCol, BForm, BFormGroup, BFormInput, BButton, BAlert, BFormRadioGroup,
          ValidationProvider, ValidationObserver, vSelect
      },

      props: {
        integracaoRnds: {
            required: false,
        },
        disabled: {},
      },

      data() {
          return {
              option: [{
                  value: true,
                  text: "Sim"
              },
              {
                  value: false,
                  text: "Não"
              },
              ],
              variant: 'custom-blue',
              valueIntegracao: null
          }
      },
      mounted() {
        this.valueIntegracao = this.integracaoRnds
        this.setVariant(this.integracaoRnds);
      },
      methods: {
        emitEventIntegracaoRnds() {
            this.$emit('integracaoRnds', this.integracaoRnds);
        },
        setVariant(value){
            let variantClass = 'custom-blue';
            if(value){
                variantClass = 'success';
            }
            if(value === false){
                variantClass = 'danger';
            }
            this.variant = variantClass;
        }
      },

      watch: {
          valueIntegracao(value) {
            this.setVariant(value)
            this.$emit('setIntegracaoRnds', value)
          },
          integracaoRnds(){
            this.valueIntegracao = this.integracaoRnds
          }
      }
  }
  </script>
